
import React from 'react'
import DescargarItemComplex from '../utils/DescargarItem/DescargarItemComplex'
import ReactPlayer from 'react-player'
import PolizaDigitalLinks from './PolizaDigitalLinks'
import SecondPolizaComp from './SecondPolizaComp'

const FirstPolizaComp = () => {
  return (
    <>
      <h6 className="digital-subtitle">
        ¿Qué es una Póliza de Caución con Firma Digital?
      </h6>

      <p className="digital-text">
        Se trata de una póliza guardada en formato PDF a la que se le agrega un certificado de firma digital. Este certificado hace imposible que alteres el contenido del PDF y acredita la identidad de la compañía de seguros conforme con lo establecido en el Código Civil y en la Ley de Firma Digital. A esto Afianzadora le agrega su propia seguridad, insertando un código QR y un link a nuestro sitio web para que puedas corroborar que los datos de la póliza que recibas coincidan y descargarte una copia de la misma si lo necesitás. Así de fácil. Recibís tu PDF firmado digitalmente y se lo hacés llegar al Asegurado.
      </p>

      <h6 className="digital-subtitle">
        ¿Cómo visualizar las pólizas con Legalización y Certificación?
      </h6>

      <p className="digital-text">
        A continuación, un breve instructivo en el cual mostramos 4 simples pasos para acceder a nuestras pólizas Legalizadas o Certificadas.
      </p>

      <div className="vimeo-box">
        <ReactPlayer
          url="https://www.youtube.com/watch?v=XCcexLp19t4"
          controls
          playsinline
          width="100%"
          height="300px"
          
        />
      </div>

      <h6 className="digital-subtitle">
        ¿Cómo verificar la validez de una firma digital?
      </h6>

      <div>
        <div className="first">
          <h6>POR ÚNICA VEZ</h6>
          <DescargarItemComplex
            title="Descargar e Instalar el Adobe Acrobat Reader DC"
            fileDownload="https://get.adobe.com/reader/?loc=es"
          />
        </div>

        <div className="vimeo-box">
          <ReactPlayer
            url="https://www.youtube.com/watch?v=fhK2dO44WdI"
            controls
            playsinline
            width="100%"
            height="300px"
            
          />
        </div>

        <div className="two-column">
          <div className="first">
            <h6>
              DESCARGAR E INSTALAR LOS CERTIFICADOS NECESARIOS PARA HACER LA
              VALIDACIÓN:
            </h6>

            <PolizaDigitalLinks
              caracter="A"
              title="El Certificado Raiz de Argentina"
              link="https://acraiz.gov.ar/acraizra.crt"
              linkName="https://acraiz.gov.ar/acraizra.crt"
            />

            <PolizaDigitalLinks
              caracter="B"
              title="El Certificado de la Autoridad Certificante de nuestra Firma Digital"
              link="https://www.encodesa.com.ar/firma-digital/encode.crt"
              linkName="https://www.encodesa.com.ar/firma-digital/encode.crt"
            />

            <PolizaDigitalLinks
              caracter="C"
              title="El Certificado de Afianzadora Latinoamericana"
              link="/Certificados/EMP-20227065908-307091879411164766.crt"
              linkName="Descargar el certificado"
            />
          </div>
        </div>

        <div className="vimeo-box">
          <ReactPlayer
            url="https://www.youtube.com/watch?v=PEfrDlmvxik"
            controls
            width="100%"
            height="300px"
            
          />
        </div>

        <div className="digital-block">
          <h6>
            CADA VEZ QUE NECESITES VERIFICAR UNA PÓLIZA DE AFIANZADORA:
          </h6>

          <p className="digital-text">
            Abrir el PDF con tu Acrobat Reader y consultar el panel de firma
            digital para verificar su validez y acceder a los detalles de la
            misma.
          </p>
        </div>

        <div className="vimeo-box">
          <ReactPlayer
            url="https://www.youtube.com/watch?v=iKbw69UMfUg"
            controls
            width="100%"
            height="300px"
            
          />
        </div>

        <div className="second-poliza-mobile">
          <SecondPolizaComp />
        </div>
      </div>
    </>
  )
}

export default FirstPolizaComp
